import React from "react";
import "./Team.css";

export const Team = (props) => {
  return (
    <div id="team" className="text-center">
      <div className="container">
        <div className="col-md-8 col-md-offset-2 section-title">
          <h2>L'ÉQUIPE DESTINS DE FEMMES</h2>
          <p>
          Découvrez les personnes engagées derrière Destins de Femmes, une équipe passionnée qui met en lumière les récits et combats des femmes à travers le monde.
          </p>
        </div>
      </div>
      <div id="row">
          <div className="team-container">

            {props.data
              ? props.data.map((d, i) => (
                  <div key={`${d.name}-${i}`} className="col-md-3 col-sm-6 team">
                    <div className="thumbnail">
                      {d.url ? (
                        <a href={d.url} target="_blank" rel="noopener noreferrer">
                          <img src={d.img} alt={d.name} className="team-img hoverable" />
                        </a>
                      ) : (
                        <img src={d.img} alt={d.name} className="team-img" />
                      )}
                      <div className="caption">
                        <h4>{d.name}</h4>
                        <p>{d.job}</p>
                      </div>
                    </div>
                  </div>
                ))
              : "loading"}
          </div>
        </div>
    </div>
  );
};
